// Session-list version state and the grab-bag atoms that moved here from
// `src/atoms/sessionAtoms.tsx`. The desktop recording prompts stay in that
// app file. LEGACY WRITABLE ATOM EXPORT: recorded in the package's
// LEGACY-ATOM-EXPORTS.md burn-down (arch §5 law 6) — curation to a
// hook/command shape is a named follow-up, never part of the move.
//
// Store identity (the capture lesson): the package's version-dispatched
// COMMANDS (`sessionsListCache.ts`) read `sessionQueryVersionAtom` via `getDefaultStore()`,
// exactly as the app-side originals did. That pins the contract to the
// production (provider-less) jotai default store — a Provider-scoped store
// would silently diverge. The app runs provider-less today; if that ever
// changes, these commands must take the store as a parameter.

import { atom } from 'jotai';

/**
 * Controls which version of the sessions query hook to use:
 * - v1: Fetches all sessions at once (useQuerySessions.ts)
 * - v2: Fetches in pages with infinite query (useQuerySessionsV2.ts)
 * - v3: Fetches in pages with pagination using infinite query (useQuerySessionsWithPagination.ts)
 */
export const sessionQueryVersionAtom = atom<'v1' | 'v2' | 'v3'>('v2');

export const createDocumentModalOpen = atom<boolean>(false);

export const askAiInputTextAtom = atom<string>('');

export const scheduleDateAtom = atom<Date | undefined>(undefined);

export const isCreatingForContextOnlySessionAtom = atom<boolean>(false);

// Documents generated in this browser session (key: documentId).
export const documentsGeneratedInSessionAtom = atom<Set<string>>(new Set<string>());

/** Optimistic document ids not yet in the server response, so their tabs stay visible. */
export const processingDocumentIdsAtom = atom<Set<string>>(new Set<string>());

/**
 * True while the user views a session owned by someone else (raw ownership check:
 * `kinde_gp_id` differs from the current user). Unlike `isReviewingOtherUser`,
 * team settings do not affect it. Used to pass `session_id` to patient-profile
 * APIs so the backend can verify access. Defaults to `false`.
 */
export const isViewingOtherSessionAtom = atom<boolean>(false);
